import React from 'react'
import type { FC } from 'react'
interface Props {
  className?: string;
  color?: string;
  size?: number | string;
  rotateOnRtl?: boolean;
}
export const IconCooker: FC<Props> = ({
  color = 'currentColor',
  size = 24,
  className,
  rotateOnRtl = false,
  ...rest
}) => {
  const props = {
    width: size,
    height: size,
    fill: color,
    // stroke: color,
    className,
    viewBox: '0 0 24 24',
    ['data-rotateonrtl']: false,
    ...rest,
  }
  return /*#__PURE__*/ React.createElement(
    'svg',
    Object.assign(
      {
        xmlns: 'http://www.w3.org/2000/svg',
        width: 24,
        height: 24,
        viewBox: '0 0 24 24',
      },
      props
    ),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M14 4h-4c-.6 0-1-.4-1-1s.4-1 1-1h4c.6 0 1 .4 1 1s-.4 1-1 1zm6 5h1c.6 0 1 .4 1 1s-.4 1-1 1h-1v6c0 2.2-1.8 4-4 4H8c-2.2 0-4-1.8-4-4v-6H3c-.6 0-1-.4-1-1s.4-1 1-1h1c0-2.2 1.8-4 4-4h8c2.2 0 4 1.8 4 4zm-4-2H8c-1.1 0-2 .9-2 2h12c0-1.1-.9-2-2-2zm-3 8h-2v4h2v-4zm3 4c1.1 0 2-.9 2-2v-6H6v6c0 1.1.9 2 2 2h1v-5c0-.6.4-1 1-1h4c.6 0 1 .4 1 1v5h1z',
      fillRule: 'evenodd',
      clipRule: 'evenodd',
    })
  )
}
